// Mock service for form submissions
// This will be replaced with actual backend integration later

export const submitContactForm = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Log form data to console (simulating sending to backend)
  console.log('Form submitted:', formData);
  
  // Simulate successful submission
  return {
    success: true,
    message: 'Form submitted successfully'
  };
};

export const requestProjectDetails = async (email) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Project details requested for:', email);
  
  return {
    success: true,
    message: 'Project details request received'
  };
};
